import type { TodoFile } from "../../../../../../utils/backend-types";

interface GetLatestDocumentsParams {
  documents?: Array<TodoFile>;
  numberOfDocuments?: number;
}

export function getLatestDocuments({
  documents,
  numberOfDocuments
}: GetLatestDocumentsParams): TodoFile[] {
  if (!documents || documents.length === 0) {
    return [];
  }

  return documents
    .sort((a, b) => b.id - a.id)
    .slice(0, numberOfDocuments ?? documents.length);
}
